import { VOUCHER_CONFIG } from './constants';

export const filterList = (list, query) => {
  if (!query) return list;
  const q = query.toLowerCase();
  return [
    ...list.filter(i => i?.toLowerCase().startsWith(q)),
    ...list.filter(i => !i?.toLowerCase().startsWith(q) && i?.toLowerCase().includes(q)),
  ];
};

export const fmt = (n) => (!n || isNaN(n)) ? '' :
  Number(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const parseFieldId = (id) => {
  if (id?.startsWith('item_'))    { const [,i,c] = id.split('_'); return { type:'item',    index:+i, col:c }; }
  if (id?.startsWith('journal_')) { const [,i,c] = id.split('_'); return { type:'journal', index:+i, col:c }; }
  if (id?.startsWith('charge_'))  { const [,i,c] = id.split('_'); return { type:'charge',  index:+i, col:c }; }
  return { type: id };
};

export const makeInitialForm = (vType = 'Sales') => ({
  party:       { text:'', value:'' },
  sales:       { text:'', value:'' },
  purchase:    { text:'', value:'' },
  journalRows: [
    { drCr: VOUCHER_CONFIG[vType]?.defaultDrCr[0] || 'Dr', ledger:{ text:'', value:'' }, debit:'', credit:'' },
  ],
  items:       [{ name:{ text:'', value:'' }, qty:'', rate:'', disc:'', amount:'', batch:'', expiry:'', mrp:'' }],
  charges:     [{ ledger:{ text:'', value:'' }, amount:'' }],
  narration:   '',
});

export const parseAmt = (v) => parseFloat(String(v || "").replace(/,/g, "")) || 0;

export const parseBal = (str) => {
  if (!str || str === '0.00' || str === '0') return { amt: 0, type: 'Dr' };
  const parts = str.replace(/,/g, '').split(' ');
  return { amt: parseFloat(parts[0]) || 0, type: parts[1] || 'Dr' };
};

export const formatBal = (amt, type) => {
  if (amt === 0) return '0.00';
  return `${amt.toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits:2})} ${type}`;
};

export const calculateNewBalance = (balStr, addAmt, addType) => {
  if (addAmt === 0) return balStr;
  let { amt, type } = parseBal(balStr);
  if (amt === 0) type = addType; 
  
  if (type === addType) {
    amt += addAmt;
  } else {
    amt -= addAmt;
    if (amt < 0) {
      amt = Math.abs(amt);
      type = addType;
    }
  }
  return formatBal(amt, type);
};

export const getTotals = (rows) => {
  const drTotal = rows.reduce((s, r) => s + (r.drCr === 'Dr' ? (parseAmt(r.debit) || 0) : 0), 0);
  const crTotal = rows.reduce((s, r) => s + (r.drCr === 'Cr' ? (parseAmt(r.credit) || 0) : 0), 0);
  return { drTotal, crTotal, isBalanced: Math.abs(drTotal - crTotal) < 0.005 };
};

export const updateStockStr = (stockStr, addQty) => {
  if (!stockStr) return `${addQty} Nos`;
  const parts = stockStr.split(' ');
  const curQty = parseFloat(parts[0]) || 0;
  const unit = parts[1] || 'Nos';
  return `${curQty + addQty} ${unit}`;
};
